
    var runtime = require('vue-svg-component-runtime')
    module.exports = {
      __esModule: true,
      default: runtime.svgComponent({
  "tag": "svg",
  "attrsMap": {
    "width": "16px",
    "height": "16px",
    "viewBox": "0 0 16 16",
    "version": "1.1",
    "xmlns": "http://www.w3.org/2000/svg",
    "xmlns:xlink": "http://www.w3.org/1999/xlink"
  },
  "children": [
    {
      "tag": "title",
      "children": [
        {
          "text": "批量操作"
        }
      ]
    },
    {
      "tag": "desc",
      "children": [
        {
          "text": "Created with Sketch."
        }
      ]
    },
    {
      "tag": "g",
      "attrsMap": {
        "id": "页面-1",
        "stroke": "none",
        "stroke-width": "1",
        "fill": "none",
        "fill-rule": "evenodd"
      },
      "children": [
        {
          "tag": "g",
          "attrsMap": {
            "id": "我的材料库",
            "transform": "translate(-488.000000, -461.000000)",
            "fill": "#999999",
            "fill-rule": "nonzero"
          },
          "children": [
            {
              "tag": "g",
              "attrsMap": {
                "id": "批量操作",
                "transform": "translate(488.000000, 461.000000)"
              },
              "children": [
                {
                  "tag": "path",
                  "attrsMap": {
                    "d": "M14.4670459,8.60867875 L14.4670458,8.60867875 C15.1238172,8.60867875 15.6562364,9.15588738 15.6562364,9.8309024 L15.6562364,14.719797 L15.6562364,14.719797 C15.6562364,15.394812 15.1238172,15.9420206 14.4670458,15.9420206 L9.71028353,15.9420206 L9.71028348,15.9420206 C9.05351211,15.9420206 8.52109291,15.394812 8.52109291,14.719797 C8.52109291,14.719797 8.52109291,14.719797 8.52109291,14.719797 L8.52109291,9.8309024 L8.52109291,9.83090258 C8.52109291,9.15588756 9.05351211,8.60867875 9.71028348,8.60867875 L14.4670458,8.60867875 L14.4670459,8.60867875 Z M6.36865807,8.57201204 L6.36865802,8.57201204 C7.02542939,8.57201204 7.55784859,9.11922067 7.55784859,9.79423569 L7.55784859,14.6831303 L7.55784859,14.6831303 C7.55784859,15.3581453 7.02542939,15.9053539 6.36865802,15.9053539 L1.61189573,15.9053539 L1.61189568,15.9053539 C0.955124304,15.9053539 0.422705103,15.3581453 0.422705103,14.6831303 C0.422705103,14.6831303 0.422705103,14.6831303 0.422705103,14.6831303 L0.422705103,9.79423569 L0.422705103,9.79423587 C0.422705103,9.11922085 0.955124304,8.57201204 1.61189568,8.57201204 L6.36865797,8.57201204 L6.36865807,8.57201204 Z M14.4670459,9.8309024 L9.71028358,9.8309024 L9.71028358,14.719797 L14.4670459,14.719797 L14.4670459,9.8309024 Z M6.36865807,9.79423569 L1.61189578,9.79423569 L1.61189578,14.6831303 L6.36865807,14.6831303 L6.36865807,9.79423569 Z M14.4789378,0.25722459 L14.4789377,0.25722459 C15.1357091,0.25722459 15.6681283,0.804433213 15.6681283,1.47944823 L15.6681283,6.36834281 L15.6681283,6.36834281 C15.6681283,7.04335783 15.1357091,7.59056646 14.4789377,7.59056646 L9.72217544,7.59056646 L9.72217538,7.59056646 C9.06540401,7.59056646 8.53298481,7.04335783 8.53298481,6.36834281 C8.53298481,6.36834281 8.53298481,6.36834281 8.53298481,6.36834281 L8.53298481,1.47944823 L8.53298481,1.47944842 C8.53298481,0.804433398 9.06540401,0.25722459 9.72217538,0.25722459 L14.4789377,0.25722459 L14.4789378,0.25722459 Z M14.4789378,1.47944823 L9.72217549,1.47944823 L9.72217549,6.36834281 L14.4789378,6.36834281 L14.4789378,1.47944823 Z M7.05719941,0.557891607 L7.05719946,0.557891607 C7.46705584,0.581188911 7.78093341,0.941559069 7.75826632,1.36279845 C7.75087349,1.5001825 7.70751371,1.63296335 7.63276769,1.74711522 L7.5566595,1.84489311 L3.76670914,6.11778697 L3.76670912,6.11778699 C3.69054147,6.20066368 3.59700327,6.26461539 3.49319529,6.3047872 L3.38141138,6.34023169 L3.25654637,6.3561206 L3.25654635,6.3561206 C3.10262978,6.36288047 2.95049143,6.32015781 2.8213026,6.23389823 L2.72854573,6.16056482 L0.3989214,4.16222916 L0.398921368,4.16222913 C0.0943882436,3.87934547 0.0706397363,3.39629404 0.345878266,3.08330166 C0.463527677,2.94951438 0.623435346,2.86281824 0.797300582,2.83856092 L0.932868307,2.8324498 L1.04584141,2.84589426 C1.13146313,2.86422762 1.21232809,2.89722766 1.2872471,2.94489438 L1.39308506,3.02678336 L3.18162768,4.52645177 L6.47330719,0.796225211 L6.47330714,0.796225263 C6.54517234,0.718078574 6.63230359,0.656433815 6.72898311,0.615336163 L6.82768593,0.581113901 L6.94184823,0.560336099 L7.05601052,0.557891607 L7.05719941,0.557891607 Z",
                    "id": "形状"
                  }
                }
              ]
            }
          ]
        }
      ]
    }
  ]
})
    }
  